import { User } from '../../../../types/user.model';
import { Group } from '../../../../types/group.model';
import { RequestState } from '../../../../types/request-state.model';

const PREFIX = '[User]';

export const TEST = `${PREFIX} TEST`;

export const GET_CURRENT_USER = `${PREFIX} GET_CURRENT_USER`;
export const GET_CURRENT_USER_IN_PROGRESS = `${PREFIX} GET_CURRENT_USER_IN_PROGRESS`;
export const GET_CURRENT_USER_SUCCESS = `${PREFIX} GET_CURRENT_USER_SUCCESS`;
export const GET_CURRENT_USER_FAIL = `${PREFIX} GET_CURRENT_USER_FAIL`;
export const GET_GROUPS_SUCCESS = `${PREFIX} GET_GROUPS_SUCCESS`;
export const GET_GROUPS_FAIL = `${PREFIX} GET_GROUPS_FAIL`;

export const LOGIN = `${PREFIX} LOGIN`;
export const LOGIN_SUCCESS = `${PREFIX} LOGIN_SUCCESS`;
export const LOGIN_FAIL = `${PREFIX} LOGIN_FAIL`;

export const LOGOUT = `${PREFIX} LOGOUT`;
export const LOGOUT_SUCCESS = `${PREFIX} LOGOUT_SUCCESS`;
export const LOGOUT_FAIL = `${PREFIX} LOGOUT_FAIL`;

export interface UserState {
  currentUser?: User;
  currentGroups?: Group[];
  getCurrentUserState?: RequestState;
}

export interface UserAction {
  type: string,
  payload?: UserState
}